<div class="row header-container">
  <div class="col-12">
    <h1 class="page-title">{{pageTitle}}</h1>
    <p class="description">{{pageDescription}}</p>
  </div>
</div>
<div class="row">
  <div class="col-12 tickets">
    @if (!(isLoaded$ | async) ) {
      @if (tickets$ | async; as tickets) {
        <table class="table-tickets w-100 border-bottom">
          <thead>
            <tr class="background-grey height-35">
              <th class="pl-3">{{'myTickets.application' | cxTranslate}}</th>
              <th>{{'myTickets.orderNumber' | cxTranslate}}</th>
              <th>{{'myTickets.typeOfIncidence' | cxTranslate}}</th>
              <th>{{'myTickets.dateOfIncidence' | cxTranslate}}</th>
              <th>{{'myTickets.upgrade' | cxTranslate}}</th>
              <th>{{'myTickets.status.label' | cxTranslate}}</th>
            </tr>
          </thead>
          <tbody>
            @for (ticket of tickets.entities.value.tickets; track ticket) {
              <tr class="height-35 border-bottom">
                <td class="pl-3">{{ticket.ticketNumber}}</td>
                <td>{{ticket.subject}}</td>
                <td>{{ticket.category}}</td>
                <td>{{ticket.creationDate | dateEs}}</td>
                <td>{{ticket.lastModificationDate | dateEs}}</td>
                <td [class]="ticket.status | lowercase">{{'myTickets.status.' + ticket.status+ '.label' | cxTranslate}}</td>
                <td class="td-mobile">
                  <div class="my-incidents-container">
                    <div class="application"><span>{{'myTickets.application' | cxTranslate}}:</span>{{ticket.ticketNumber}}<div class="separator"></div></div>
                    <div class="orderNumber"><div>{{'myTickets.orderNumber' | cxTranslate}}:</div>{{ticket.subject}}</div>
                    <div class="typeOfIncidence"><div>{{'myTickets.typeOfIncidence' | cxTranslate}}:</div>{{ticket.category}}</div>
                    <div class="dateOfIncidence"><div>{{'myTickets.dateOfIncidence' | cxTranslate}}:</div>{{ticket.creationDate | dateEs}}</div>
                    <div class="upgrade"><div>{{'myTickets.upgrade' | cxTranslate}}:</div>{{ticket.lastModificationDate | dateEs}}</div>
                    <div class="status"><span class=status-label>{{'myTickets.status.label' | cxTranslate}}:</span><span [class]="ticket.status | lowercase">{{'myTickets.status.' + ticket.status+ '.label' | cxTranslate}}</span></div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <div class="cx-order-history-sort bottom row">
          @if (tickets?.entities?.value?.pagination?.totalPages > 1) {
            <div class="cx-order-history-pagination">
              <cx-pagination
                [pagination]="tickets.entities.value.pagination"
                (viewPageEvent)="pageChange($event)"
              ></cx-pagination>
            </div>
          }
        </div>
      }
      <div class="my-tickets-status-container">
        <div class="title">{{'myTickets.status.title' | cxTranslate }}</div>
        <div><span class="open">{{'myTickets.status.OPEN.label' | cxTranslate }}:</span>
        <span class="ml-2">{{'myTickets.status.OPEN.description' | cxTranslate}}</span>
      </div>
      <div><span class="inprocess">{{'myTickets.status.INPROCESS.label' | cxTranslate }}:</span>
      <span class="ml-2">{{'myTickets.status.INPROCESS.description' | cxTranslate}}</span>
    </div>
  </div>
} @else {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}

</div>
</div>
